export default class ApiResponseError {
    response: Response
    name?: string
    message?: string
    code?: string

    constructor(response: Response) {
        this.response = response;
        this.name = 'ApiResponseError';
        this.message = response.statusText;
        this.code = response.status + '';
    }
}